export const PaymentLocation = () => 'Pagável em qualquer banco';
